module.exports = __webpack_public_path__ + "static/bch-icon-qrcode-ez-782dafd033c8ac40729326378552d134.png";